
<div class="title">
<mat-icon>help</mat-icon>
{{('help' | translate)()}}
<p style="flex-grow: 1;"></p>
<button class="invisible" (click)="close()">
  <ngt-button matIcon="close" shape="square" styling="tertiary"></ngt-button>
</button>
</div>

<div class="body">
  <div class="banner">
    <div class="banner-text">
      <div class="banner-title">{{('help:helpCenter' | translate)()}}</div>
      <div class="banner-description">{{('help:helpCenterDescription' | translate)()}}</div>
    </div>
  </div>

  <div class="video-embedding">
    <iframe [src]="trustUrl(videos.mainHelpVideo)" style="width: 100%; aspect-ratio: calc(16/9);" width="1100" height="620" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
  </div>

  <!-- <div class="content">
    <div class="card">
      <div class="video"></div>
      <div class="card-text">
        <div class="card-title">{{('help:uiAndNav' | translate)()}}</div>
        <div class="card-description">{{('help:lorem' | translate)()}}</div>
      </div>
    </div>

    <div class="card">
      <div class="video"></div>
      <div class="card-text">
        <div class="card-title">{{('help:createGoals' | translate)()}}</div>
        <div class="card-description">{{('help:lorem' | translate)()}}</div>
      </div>
    </div>

    <div class="card">
      <div class="video"></div>
      <div class="card-text">
        <div class="card-title">{{('help:editTasks' | translate)()}}</div>
        <div class="card-description">{{('help:lorem' | translate)()}}</div>
      </div>
    </div>
  </div> -->
  <div class="button-row">
    @if (helpPageAutostart()) {
      <button class="invisible" (click)="hideAndRemember()">
        <ngt-button styling="secondary">{{i18n.translate('dontShowAgain')()}}</ngt-button>
      </button>
    }
  </div>
</div>
